import {connect} from '../../app/connect';
import IssueCreatePanelWrapper from './IssueCreatePanelWrapper';
import {
  setPushpinExtensionAction,
  setTargetUrnAction,
  configureSheetsAction,
  configureDocumentSuccessAction
} from '../../app/actions';

const mapDispatchToProps = {
  setPushpinExtensionAction,
  setTargetUrnAction,
  configureSheetsAction,
  configureDocumentSuccessAction
};

export default connect(
  null,
  mapDispatchToProps
)(IssueCreatePanelWrapper);
